/**
 * @fileoverview Hero section component for landing page
 * @author ISCRI Team
 */

import { Link } from "react-router-dom";
import { ROUTES } from "@router";
import logo from "@assets/images/logo-white.png";
import iscri_Chart from "@assets/images/RUS-UKR.png";
import "./styles/HeroSection.css";

/**
 * Hero section with title, subtitle, CTA buttons and sample chart
 * Exact reproduction from iscri.html prototype
 * @returns {JSX.Element} Hero section component
 */
const HeroSection = () => {
  return (
    <section className="hero">
      <div className="container hero-content">
        <div className="hero-text">
          <h1 className="hero-title">Interstate Conflictual Relations Index</h1>
          <p className="hero-subtitle">
            The recent months have underlined how geopolitical tensions between
            countries can influence trade and capital flows and, more broadly,
            world GDP. To help its stakeholders to get a timely comprehensive
            geopolitical picture, SKEMA Business School has decided to create a
            new index, ISCRI, aiming at tracking in real-time the conflictual
            relationships between any countries in the world, especially those
            critical in the world economy system.
          </p>
          <div className="hero-buttons" style={{ marginTop: "2rem" }}>
            <Link to={ROUTES.SIMPLE} className="button button-primary">
              Explore Data
            </Link>
            <Link to={ROUTES.METHODOLOGY} className="button button-outline">
              Learn More
            </Link>
          </div>
        </div>

        <div className="hero-image">
          <div className="hero-chart">
            <img
              src={iscri_Chart}
              alt="ISCRI sample chart"
              className="iscri-chart-image"
            />
          </div>

          <div className="skema-partnership">
            <img src={logo} alt="SKEMA Logo" />
            <span>Partnership</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;